export const state = () => {
  return {
    items: []
  };
};
export const getters = {
  getItems: (state) => {
    return state.items;
  }
};

export const mutations = {
  setNewSpeakers: (state, payload) => {
    state.items = payload.append
      ? state.items.concat(payload.data)
      : payload.data;
  }
};

export const actions = {
  setSpeakers({ commit }, payload) {
    commit('setNewSpeakers', payload);
  },
  // `payload.category` (a speaker category's server value) and
  // `payload.search` are filtered server-side — the speaker list
  // endpoint does not return per-speaker categories, so client-side
  // category matching can't work. Called with no payload it fetches
  // the full list (default behaviour).
  async fetchSpeakers({ commit }, payload = {}) {
    try {
      const ApiClient = (await import('@/client')).default;
      const response = await ApiClient.getSpeakers(
        1,
        100,
        (payload && payload.search) || '',
        (payload && payload.category) || ''
      );
      if (response?.data) {
        const data = Array.isArray(response.data)
          ? response.data
          : response.data.items || response.data.data || [];
        commit('setNewSpeakers', { data, append: false });
      }
    } catch (e) {
      // Silently fail — speakers section will stay empty
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
